import { RadioInput } from '@synoptic/ui-kit/radio-input/radio-input.js';
import { Textarea } from '@synoptic/ui-kit/textarea/textarea.js';
import { Controller, UseFormReturn } from 'react-hook-form';
import { AiFilterPassValue } from '@/__generated__/graphql';
import { AiFilterFormValues } from '../types';
import {
  formFieldErrorMessage,
  formFieldLabel,
  radioInput,
  radioInputContainer,
} from './manage-filter.css';

interface ManualFilterFormFieldsProps {
  formData: UseFormReturn<AiFilterFormValues>;
  evaluateFilterOnValidForm: (newValue: Partial<AiFilterFormValues>) => void;
}

export const ManualFilterFormFields = ({
  formData,
  evaluateFilterOnValidForm,
}: ManualFilterFormFieldsProps) => {
  const { control, formState } = formData;

  return (
    <>
      <Controller
        name="prompt"
        control={control}
        rules={{ required: 'Prompt is required' }}
        render={({ field }) => (
          <Textarea
            autoResize
            rows={1}
            label="Your prompt"
            placeholder="e.g., Is this breaking news?"
            errorMessage={formState.errors.prompt?.message}
            {...field}
            onBlur={() => {
              evaluateFilterOnValidForm({
                prompt: field.value,
              });
              field.onBlur();
            }}
          />
        )}
      />

      <div>
        <Controller
          name="passValue"
          control={control}
          rules={{
            required: 'Pass filter when prompt output is required',
          }}
          render={({ field }) => {
            return (
              <>
                <label className={formFieldLabel}>
                  Pass filter when prompt output is
                </label>
                <div className={radioInputContainer}>
                  <RadioInput
                    type="radio"
                    value={AiFilterPassValue.Yes}
                    ref={field.ref}
                    className={radioInput}
                    checked={field.value === AiFilterPassValue.Yes}
                    onChange={() => {
                      field.onChange(AiFilterPassValue.Yes);
                      evaluateFilterOnValidForm({
                        passValue: AiFilterPassValue.Yes,
                      });
                    }}
                  >
                    Yes
                  </RadioInput>
                  <RadioInput
                    type="radio"
                    value={AiFilterPassValue.No}
                    className={radioInput}
                    checked={field.value === AiFilterPassValue.No}
                    onChange={() => {
                      field.onChange(AiFilterPassValue.No);
                      evaluateFilterOnValidForm({
                        passValue: AiFilterPassValue.No,
                      });
                    }}
                  >
                    No
                  </RadioInput>
                </div>
                {formState.errors.passValue?.message && (
                  <p className={formFieldErrorMessage}>
                    {formState.errors.passValue.message}
                  </p>
                )}
              </>
            );
          }}
        />
      </div>
    </>
  );
};
